import { Box, Button, FormControl, InputAdornment, MenuItem, Select, Stack, Tab, Tabs, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import searchIcon from '../../../assets/icons/searchicon.svg';
import CustomTable from 'src/components/CustomTable';
import useColums from './hooks/useColums';
import CreateGroupModal from './modals/CreateGroup';
import useModalControl from 'src/components/cards/useModalControl';
import getCampianGroups from 'src/services/campian/getGroupData';
import { useAuthContext } from 'src/auth/useAuthContext';
import AssignNumberModal from './modals/AssignNumber';
import getCampianAssignGroups from 'src/services/campian/getAssignGroupData';
import { debounce } from 'lodash';
import usePagination from 'src/hooks/usePagination';
import Pagination from 'src/components/pagination';
import DeleteModal from './modals/DeleteModal';
import getVendoreRequestNumbers from 'src/services/campian/getVendoreRequestNumbers';
import StatusModal from './modals/StatusModal';
import getMetaAccounts from 'src/services/campian/getMetaAccounts';
import AccountsNumbers from './modals/AccountsNumbers';
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
export default function AddGroupPage() {
    const { user } = useAuthContext()
    const [loading, setLoading] = useState(false)
    const { page, setPage, page_size, total_records, setTotal_records, totalPages, setTotalPages, handlePageSize } = usePagination()
    const [editData, setEditData] = useState()
    const { open, handleCloseModal, handleOpenModal } = useModalControl()
    const { open: isOpen, handleCloseModal: handleAssignCloseModal, handleOpenModal: handleAssignOpenModal } = useModalControl()
    const { open: isDeleteOpen, handleCloseModal: handleDeleteAssignCloseModal, handleOpenModal: handleDeleteAssignOpenModal } = useModalControl()
    const { open: isStatusOpen, handleCloseModal: handleStatusAssignCloseModal, handleOpenModal: handleStatusAssignOpenModal } = useModalControl()
    const { open: isAccountOpen, handleCloseModal: handleAccountCloseModal, handleOpenModal: handleAccountOpenModal } = useModalControl()
    const [type, setType] = useState('group')
    const { colums } = useColums(setEditData, handleOpenModal, handleAssignOpenModal, handleDeleteAssignOpenModal, setType, handleStatusAssignOpenModal,handleAccountOpenModal)
    const [search, setSearch] = useState('')
    const [reload, setReload] = useState(false)
    const handleSearch = debounce((e) => {
        setPage(0)
        setSearch(e.target.value)
    }, 600)
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setPage(0)
        setValue(newValue);
    };
    const [groupName, setGroupName] = useState([])


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const data = await getCampianGroups(user, page, page_size, search)
                setGroupName(data?._payload || [])
                setTotal_records(data?.total_records);
                setTotalPages(data?.totalPages);
            } catch (err) {
                console.log(err);

            } finally {
                setLoading(false)

            }

        }
        const fetchData1 = async () => {
            try {
                setLoading(true)
                const data = await getCampianAssignGroups(user, page, page_size, search)
                setGroupName(data?._payload || [])
                setTotal_records(data?.total_records);
                setTotalPages(data?.totalPages);

            } catch (er) {
                console.log(er);

            } finally {
                setLoading(false)

            }
        }
        const fetchData2 = async () => {
            try {
                setLoading(true)
                const data = await getVendoreRequestNumbers(user, page, page_size, search)
                setGroupName(data?._payload || [])
                setTotal_records(data?.total_records);
                setTotalPages(data?.totalPages);

            } catch (er) {
                console.log(er);

            } finally {
                setLoading(false)

            }
        }
        const fetchData3 = async () => {
            try {
                setLoading(true)
                const data = await getMetaAccounts(user, page, page_size, search)
                setGroupName(data || [])
                setTotal_records(data?.total_records);
                setTotalPages(data?.totalPages);

            } catch (er) {
                console.log(er);

            } finally {
                setLoading(false)

            }
        }
        if (value == 0) {
            fetchData()
        } else if (value == 1) {
            fetchData1()
        } else if (value == 2) {
            fetchData2()
        } else if (value == 3) {
            fetchData3()
        }
    }, [value, search, page_size, page, reload])
    return (
        <div>
            <Stack spacing={1}>
                <Typography variant="h4">Templates Grouping</Typography>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <TextField
                        fullWidth
                        id="Search"
                        variant="outlined"
                        // size="small"
                        placeholder="Search"
                        backgroundColor="#FFFFFF"
                        onChange={handleSearch}
                        sx={{ maxWidth: '356px' }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Box component="img" src={searchIcon} alt="Search Icon" sx={{ width: 30, height: 30 }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Stack direction="row" spacing={1}>
                        <Button variant="contained" onClick={handleOpenModal}>Create Group</Button>
                        {/* <Button variant="contained" onClick={handleAssignOpenModal}>Assign Number</Button> */}
                    </Stack>
                </Stack>
            </Stack>
            <Box sx={{ width: '100%', marginTop: "10px" }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Group Name" {...a11yProps(0)} />
                        <Tab label="Group Numbers" {...a11yProps(1)} />
                        <Tab label="Request Numbers" {...a11yProps(2)} />
                        <Tab label="Meta Accounts" {...a11yProps(3)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <CustomTable rows={groupName} columns={colums[value]} loading={loading} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <CustomTable rows={groupName} columns={colums[value]} loading={loading} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <CustomTable rows={groupName} columns={colums[value]} loading={loading} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                    <CustomTable rows={groupName} columns={colums[value]} loading={loading} />
                </CustomTabPanel>
            {value !=3 &&    <Stack
                    direction="row"
                    sx={{ width: '100%', p: { xs: 0, sm: 3 } }}
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    gap={1}
                >
                    <Box
                        minWidth={220}
                        width={{ xs: '100%', sm: 'max-content' }}
                        alignSelf={{ xs: 'center', sm: 'auto' }}
                    >
                        <Typography
                            sx={{ textAlign: { xs: 'center', sm: 'normal' } }}
                            color="primary"
                            variant="body1"
                        >

                            {`Showing ${page !== 0 ? page * page_size : 1}  to ${(page + 1) * page_size > total_records ? total_records : (page + 1) * page_size
                                } of ${total_records} entries`}


                        </Typography>
                    </Box>
                    <Box sx={{ order: { xs: 2, sm: 0 } }} flex={{ xs: 0, sm: 1 }}>
                        <FormControl sx={{ maxWidth: 'max-content', flexGrow: 1 }} fullWidth>
                            <Select
                                className="custom-select"
                                sx={{
                                    '&.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.custom-select':
                                    {
                                        height: '37px',
                                    },
                                }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={page_size}
                                onChange={handlePageSize}
                                color="primary"
                                renderValue={() => `${page_size} per page`}
                            >
                                <MenuItem value={15}>15</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={75}>75</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Pagination page={page} setPage={setPage} totalPages={totalPages} />
                </Stack>}
            </Box>


            {open && <CreateGroupModal open={open} close={() => { handleCloseModal(); setEditData() }} editData={editData} setReload={setReload} />}
            {isOpen && <AssignNumberModal open={isOpen} close={() => { handleAssignCloseModal(); setEditData() }} editData={editData} setReload={setReload} />}
            {isDeleteOpen && <DeleteModal open={isDeleteOpen} close={() => { handleDeleteAssignCloseModal(); setEditData() }} editData={editData} setReload={setReload} type={type} />}
            {isStatusOpen && <StatusModal open={isStatusOpen} close={() => { handleStatusAssignCloseModal(); setEditData() }} editData={editData} setReload={setReload} />}
            {isAccountOpen && <AccountsNumbers open={isAccountOpen} close={() => { handleAccountCloseModal(); setEditData() }} editData={editData} setReload={setReload} />}
        </div>
    )
}
